<template>
    <el-drawer title="选择演出" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="800px"
        append-to-body @close="close">
        <div class="drawer-content" v-loading="listLoading">
            <div class="page-filter-box">
                <el-row :gutter="10">
                    <el-col :sm="12">
                        <el-input v-model="params.searchValue" class="input-with-select" size="small">
                            <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                <el-option label="演出ID" :value="1"></el-option>
                                <el-option label="演出名称" :value="2"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>
                    <el-col :sm="12" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="list-box">
                <div v-for="(item, index) in dataList" :key="index" class="item" :class="currentIndex === index ? 'current' : ''" @click="selectAction(index)">
                    <div class="poster"><el-image :src="item.poster | coverImage(300, 400)"></el-image></div>
                    <div class="info">
                        <div class="name">{{ item.title }}</div>
                        <div>{{ item.cityName }} {{ item.siteName }}</div>
                        <div>{{ item.beginShowTime }}</div>
                        <div>
                            <div><span class="color-info">总库存：</span>{{ item.totalTicket }}</div>
                            <div><span class="color-info">已售：</span>{{ item.sellTicket }}</div>
                        </div>
                        <div><span class="price color-danger">￥{{ item.minPrice }}</span>起</div>
                    </div>
                    <span class="icon el-icon-success"></span>
                </div>
            </div>
            <el-empty v-if="data && dataList.length < 1" description="没有相关演出" :image-size="100"></el-empty>
            <div v-if="data" class="page-pagination-box MT20">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
	cpsType:0
}
export default {
    data() {
        return {
            drawerShow: false,
            listLoading: true,
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            currentIndex: "",
        }
    },
    watch: {
        dataList(v1, v2) {
            if (v1 != v2) {
                this.currentIndex = ""
            }
        }
    },
    methods: {
        close() {
            this.drawerShow = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            }
            this.currentIndex = "";
        },
        show() {
            this.getDataList();
            this.drawerShow = true;
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/activityList",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        selectAction(index) {
            this.currentIndex = index;
        },
        submitForm() {
            if (this.currentIndex === "") {
                return this.$message.error('请选择演出')
            }
            this.$emit('onUpdate', this.dataList[this.currentIndex]);
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer {
    max-width: 100%;

    .page-filter-box {
        .input-with-select {
            display: inline-table;
        }
    }
}

.list-box {
    display: flex;
    flex-wrap: wrap;

    .item {
        margin: 5px;
        display: flex;
        border: 1px #eee solid;
        width: 370px;
        padding: 15px;
        cursor: pointer;
        position: relative;
        border-radius: 3px;
        box-shadow: 0 2px 8px #eee;
        transition: all 0.5s ease-out;

        .poster {
            margin-right: 10px;
            background: #f8f8f8;

            .el-image {
                width: 90px;
            }
        }

        .info {
            flex: 1;

            .name {
                font-size: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                height: 36px;
                line-height: 18px;
                margin: 0;
            }

            >div {
                margin-top: 6px;
                font-size: 12px;
                display: flex;
                align-items: flex-end;

                >div {
                    margin-right: 20px;
                }

                .price {
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 1;
                }
            }
        }

        .icon {
            position: absolute;
            right: 15px;
            bottom: 15px;
            color: $--color-theme;
            font-size: 18px;
            display: none;
            transition: all 0.5s ease-out;
        }

        &.current {
            border-color: $--color-theme;
            box-shadow: 0 2px 8px #bbb;

            .icon {
                display: block;
            }
        }
    }

}

::v-deep .el-empty {
    text-align: center;

    .el-empty__image {
        margin: 0 auto;
    }
}
</style>